module.exports = __webpack_public_path__ + "static/img/heroimage_qr_labo_small.3cb32f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_qr_labo_small.png
// module id = 243
// module chunks = 1